import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./custom.css";
// import "./indexold.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { SocketContext, socket } from "./context/socket";
const container = document.getElementById("root");

const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    <SocketContext.Provider value={socket}>
      <App />
    </SocketContext.Provider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
